import React from "react";
import QPhototModuleSubtopic from "../../../QPhotoModuleSubtopic";

const TheveninMeshNodalAnalysis = () => (
  <QPhototModuleSubtopic
    title="Thevenin, Mesh and Nodal Analysis"
    videos={[
      "https://www.youtube.com/embed/veAFVTIpKyM",
      "https://www.youtube.com/embed/XyfII-KnSBs",
      "https://www.youtube.com/embed/SkBAJ7TooDk",
      "https://www.youtube.com/embed/Ue3ozP_CSL4",
      "https://www.youtube.com/embed/fHj2RdOnTqg",
      "https://www.youtube.com/embed/Mwu1zaA8_f4"
    ]}
    takeaways={[
      { text: "Thevenin Question is always expected in exams." },
      { text: "One Question either mesh or nodal analysis question is expected." },
      { text: "Practice more problems." }
    ]}
    questions={[
      { image: "/beee_6.jpeg" },
      { image: "/beee_7.jpeg" },
      { image: "/beee_8.jpeg" },
      { image: "/beee_9.jpeg" },
      { image: "/beee_10.jpeg" },
      { image: "/beee_11.jpeg" }
    ]}
    exampleVideos={[]}
  />
);

export default TheveninMeshNodalAnalysis;
